webpackJsonp([72],{

/***/ 1285:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1286);


/***/ }),

/***/ 1286:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(179);

var _datetime2 = _interopRequireDefault(_datetime);

var _pt = __webpack_require__(798);

var _pt2 = _interopRequireDefault(_pt);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('pt', _pt2.default);

/***/ })

},[1285]);


// WEBPACK FOOTER //
// app/datetime.pt-9903136c47fba924787f.js